import { z } from "zod";

export const AppKeySchema = z
  .string()
  .trim()
  .regex(/^[a-z][a-z0-9-]{0,63}$/);
export const EntitlementTierSchema = z.enum(["free", "plus", "pro"]);
export const EntitlementTierCapabilityPolicySchema = z.discriminatedUnion(
  "kind",
  [
    z.object({
      capabilityKey: z.string().min(1).max(128),
      kind: z.literal("boolean"),
      contextKey: z.null(),
      values: z.object({
        free: z.boolean(),
        plus: z.boolean(),
        pro: z.boolean(),
      }),
    }),
    z.object({
      capabilityKey: z.string().min(1).max(128),
      kind: z.literal("limit"),
      contextKey: z.enum(["currentUsage", "currentDepth"]),
      values: z.object({
        free: z.number().int().nonnegative().nullable(),
        plus: z.number().int().nonnegative().nullable(),
        pro: z.number().int().nonnegative().nullable(),
      }),
    }),
  ],
);
export const EntitlementTierResponseSchema = z.object({
  accountId: z.string().uuid(),
  app: AppKeySchema,
  tier: EntitlementTierSchema,
});
export const EntitlementTokenResponseSchema = z.object({
  token: z.string().min(1),
});
export const DiscountCodeRedeemRequestSchema = z.object({
  code: z.string().trim().min(1).max(96),
  app: AppKeySchema.default("toy"),
});
export const DiscountCodeRedeemResponseSchema = z.object({
  accountId: z.string().uuid(),
  app: AppKeySchema,
  grantedTier: EntitlementTierSchema,
  effectiveTier: EntitlementTierSchema,
  expiresAt: z.string().nullable(),
  token: z.string().min(1),
});

export type EntitlementTier = z.infer<typeof EntitlementTierSchema>;
export type EntitlementTierCapabilityPolicy = z.infer<
  typeof EntitlementTierCapabilityPolicySchema
>;
